import React from 'react'

import { FiltersSidebar, Icon, Search } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { array, func, object, string } from 'prop-types'

import WithListingPageContext from 'Pods/ListingPage/Components/WithListingPageContext'
import i18n from 'Pods/Shared/I18n'

import getArrayFilters from 'Utils/getArrayFilters'

function RemainingFileFormatFilters({
  currentSelectedFilters,
  setSelectedFilters,
  currentFilters,
  trackFilterChange,
  locale = 'en',
}) {
  function handleFilterChange(selectedValues) {
    const truthyValues = selectedValues.filter(Boolean)
    const isFilterSelected = truthyValues.length > currentSelectedFilters.length
    const isFilterDeselected = truthyValues.length < currentSelectedFilters.length

    if (isFilterSelected) {
      const newFilter = truthyValues
        .filter((element) => currentSelectedFilters.every((value) => value !== element))

      if (newFilter.length) {
        const newFilterValue = newFilter.pop()
        const { filters } = currentFilters
        const matchingFilter = filters
          .find(({ value: filterValue }) => filterValue === newFilterValue)

        if (matchingFilter) {
          const { label } = matchingFilter

          trackFilterChange({ name: 'fileTypes', value: label })
        }
      }
    }

    if (isFilterDeselected) {
      const deselectedFilter = currentSelectedFilters
        .find((element) => truthyValues.every((value) => value !== element))

      if (deselectedFilter) {
        const matchingFilter = filters
          .find(({ value: filterValue }) => filterValue === deselectedFilter)

        if (matchingFilter) {
          const { label } = matchingFilter

          window.removeCurrentSearchFilter({ name: 'fileTypes', value: label })
        }
      }
    }

    return setSelectedFilters({ name: 'fileTypes', value: [...new Set(truthyValues)] })
  }

  const filters = currentFilters.filters || []
  const sidebarLabel = i18n.t('listingPage.filters.fileFormat', { ns: 'rails', lng: locale })

  return (
    <div className="remaining-filters__file-formats">
      <FiltersSidebar
        isCollapsible={false}
        filters={[{ ...currentFilters, label: sidebarLabel }]}
        selectedFilters={currentSelectedFilters}
        onFiltersChange={handleFilterChange}
        limit={8}
        isControlled
        hideLastDivider
        useNewCheckboxes
        searchPlaceholder={`Search from ${filters.length} formats`}
        textInputProps={{
          leadIcon: <Icon notSpaced svgComponent={Search} color="dark" />,
          textInputClassName: 'remaining-filters__file-formats-search-input',
        }}
        showMoreButtonType="secondary"
      />
    </div>
  )
}

RemainingFileFormatFilters.propTypes = {
  currentSelectedFilters: array.isRequired,
  setSelectedFilters: func.isRequired,
  currentFilters: object.isRequired,
  trackFilterChange: func.isRequired,
  locale: string,
}

const mapStateToProps = ({
  selectedFilters,
  setSelectedFilters,
  filtersOptions,
  trackFilterChange,
  locale,
}) => {
  const currentFilters = filtersOptions.fileTypes
  const groupsSelectedFilters = selectedFilters.fileTypes || []
  const currentSelectedFilters = getSelectedFilters(groupsSelectedFilters)
  const groupsFilters = currentFilters.filters || []

  function getSelectedFilters(filters = []) {
    return getArrayFilters(filters)
  }

  return {
    currentSelectedFilters,
    setSelectedFilters,
    currentFilters: {
      ...currentFilters,
      filters: groupsFilters,
      withTitleDivider: true,
      showMoreButtonType: 'secondary',
    },
    trackFilterChange,
    locale,
  }
}

export default WithListingPageContext(mapStateToProps)(RemainingFileFormatFilters)
